export const readFileFromBase64 = async (
  file: string,
  mime: string
): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const dataUrl = `data:${mime};base64,` + file;
    fetch(dataUrl).then((res) => resolve(res.arrayBuffer()));
  });
};
